<template>
  <div
    ref="divModalPopup"
    class="ModalPopup"
    :class="{Open:isOpen}"
    @mouseup.prevent="modalPopupHead_MouseUp"
    @mousemove.prevent="modalPopupHead_MouseMove"
    @keydown="modalPopup_keydown"
  >
    <div class="ModalPopupBox">
      <div class="ModalPopupHead" @mousedown.prevent="modalPopupHead_MouseDown">
        <div class="Flex_Table">
          <div class="Flex_Row">
            <div class="Flex_Cell">
              <slot name="title">{{title}}</slot>
            </div>
            <div class="Flex_Cell_Inline">
              <span style="cursor: pointer" class="glyphicons remove" @click.prevent="modalPopupClosed"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="ModalPopupBody">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: { type: String, default: "" },
    value: { type: Boolean, default: false },
    okButton: { default: null },
    cancelButton: { default: null }
  },
  data() {
    return {
      isOpen: this.value,
      position: null,
      isMouseDown: false,
      source: null
    };
  },
  methods: {
    show(e) {
      this.isOpen = true;
      this.$emit("input", this.isOpen);
      if (e && e.target) {
        this.source = e.target;
      }
    },
    hide(e) {
      this.isOpen = false;
      this.$emit("input", this.isOpen);
      if (this.source) {
        if (this.source.focus) {
          this.source.focus();
        }
      }
    },
    modalPopupClosed(e) {
      this.hide(e);
    },
    modalPopupHead_MouseDown(e) {
      this.isMouseDown = true;
      this.position = { x: e.pageX, y: e.pageY };
    },
    modalPopupHead_MouseUp(e) {
      this.isMouseDown = false;
    },
    modalPopupHead_MouseMove(e) {
      if (this.isMouseDown) {
        let modalPopup = this.$refs.divModalPopup;
        let modalPopupBox = modalPopup.querySelector(".ModalPopupBox");
        let mBox = modalPopup.getBoundingClientRect();
        let box = modalPopupBox.getBoundingClientRect();
        let left = box.left + e.pageX - this.position.x;
        let top = box.top + e.pageY - this.position.y;
        if (top < 0) {
          top = 0;
        }
        if (left < 0) {
          left = 0;
        }
        modalPopupBox.style.left = left + "px";
        modalPopupBox.style.top = top + "px";
        this.position = { x: e.pageX, y: e.pageY };
      }
    },
    modalPopup_keydown(e) {
      if (e.which === 27) {
        if (this.cancelButton) {
          this.cancelButton.click();
        } else {
          this.hide(e);
        }
        e.preventDefault();
        e.stopPropagation();
      } else if (e.which === 13) {
        if (this.okButton) {
          this.okButton.click();
          e.preventDefault();
          e.stopPropagation();
        }
      }
    }
  },
  watch: {
    isOpen(newValue, oldValue) {
      let _position = this.position;
      this.isOpen = newValue;
      if (newValue) {
        let xxx = this;
        let modalPopup = this.$refs.divModalPopup;
        let modalPopupBox = modalPopup.querySelector(".ModalPopupBox");
        window.setTimeout(function() {
          if (!_position) {
            let mBox = modalPopup.getBoundingClientRect();
            let box = modalPopupBox.getBoundingClientRect();
            let left = (mBox.width - box.width) / 2;
            let top = (mBox.height - box.height) / 2 - 100;
            if (top < 0) {
              top = 0;
            }
            if (left < 0) {
              left = 0;
            }
            modalPopupBox.style.left = left + "px";
            modalPopupBox.style.top = top + "px";
          }
          xxx.$emit("opened");
          modalPopup.querySelector("input").focus();
        }, 300);
      } else {
        this.$emit("closed");
      }
    },
    value(newValue, oldValue) {
      this.isOpen = newValue;
    }
  },
  mounted() {
    let _position = this.position;
    let modalPopup = this.$refs.divModalPopup;
    let modalPopupBox = modalPopup.querySelector(".ModalPopupBox");
    window.setTimeout(function() {
      if (!_position) {
        let mBox = modalPopup.getBoundingClientRect();
        let box = modalPopupBox.getBoundingClientRect();
        let left = (mBox.width - box.width) / 2;
        let top = (mBox.height - box.height) / 2 - 100;
        if (top < 0) {
          top = 0;
        }
        if (left < 0) {
          left = 0;
        }
        modalPopupBox.style.left = left + "px";
        modalPopupBox.style.top = top + "px";
      }
    }, 300);
  }
};
</script>
<style>
.ModalPopup {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1000;

  opacity: 0;
  transform: scale(0);
  transition: all 250ms;
}
.ModalPopup.Open {
  opacity: 1;
  transform: scale(1);
}
.ModalPopup .ModalPopupBox {
  position: absolute;
  background-color: white;
  color: black;
  border: solid 1px;
  border-radius: 5px;
  top: 100px;
  margin: auto;
}

.ModalPopup .ModalPopupHead {
  background-color: rgba(50, 0, 0, 0.9);
  color: white;
  font-size: 150%;
  font-weight: bold;
  border-radius: 5px 5px 0px 0px;
  margin: 2px;
  cursor: move;
}
.ModalPopup .ModalPopupHead a {
  color: white;
}
.ModalPopup .ModalPopupBody {
  padding: 10px;
  overflow: auto;
}
.ModalPopup input[type="button"] {
  background-color: rgba(20, 0, 0, 0.8);
  color: white;
}
.ModalPopup .BlockInputInner:focus-within,
.ModalPopup .BlockInputInner:active {
  background-color: rgba(20, 0, 0, 0.6);
  border: solid 1px;
}
.ModalPopup .BlockInputInner:focus-within .BlockInputLabel,
.ModalPopup .BlockInputInner:active .BlockInputLabel {
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/ekkControls/ModalPopup.vue